import React, { useEffect, useState } from 'react'
import ReusableDiv from 'src/helper/ReusableDiv';
import CheckoutTotal from '../Checkout/CheckoutTotal';
import { useOrderStore } from 'src/hooks/order';
import System from 'src/helper/system';
import { __remove, __set } from 'src/store/axios_indicator';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import Constants from 'src/helper/Constants';
import CheckoutOrderItemList from '../Checkout/CheckoutOrderItemList';
import Product from "@system/config/product";
import DOMAttachToSystem from 'src/captain/DOMAttachToSystem';
import Helper from 'src/helper/Helper';
import Order from "@system/config/order";
import ShowAlert from 'src/component/Global/ShowAlert';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import HelperAnalyticsEvent from 'src/support/HelperAnalyticsEvent';
import { useCartStore } from 'src/hooks/cart';
import print from "src/assets/images/print-icon.svg";
import phone from "src/assets/images/phone-icon.svg";
import emailicon from "src/assets/images/email-icon.svg";


let cartProductData = JSON.parse(localStorage.getItem(System.storageName.CART_PRODUCT_DATA))

const SuccessCheckout = () => {
    const [__check] = useAxiosIndicatorCheck();
    const {
        siteUser: { CORE },
        addressType: { SHIP_TO },
        paymentType: { CreditCard, WireTransfer, DefaultPaymentTerm, Alipay, ChinaUnionPay },
        speedBoats: { japanAbbr, apacAbbr },
        shippingCarrierType: { AVNET, INCOTERM, MANUAL } } = Constants
    const { storageName: { SUCCESS_PAGE, ORDER_FEEDBACK, CART_CHECKOUT_PLACE_ORDER }, avUserInfoData: { email, accountNumber } } = System
    const { translation: t } = System;
    const [{ }, { fetch_place_order_items }, { }] = useOrderStore();
    const [{ }, { system_alert_indicator }, { }] = useDOMAttachToSystemStore();
    const [{ CART_DATA }, { }, { }] = useCartStore();
    const [checkoutData, setCheckoutData] = useState([])
    const [firstServerCall, setFirstServerCall] = useState(true);
    const [monitorFunctionCall, setMonitorFunctionCall] = useState(false);

    const isOnlySoftwareParts = cartProductData && !Object.values(cartProductData).some(f => f.SoftwareDownloadFlag === false);
    const isCoreUser = System.getCurrentRegionWithType(apacAbbr, CORE)
    const emailId = System.getCurrentRegionWithType(apacAbbr) ? "OnlineSupport-Asia@avnet.com" : "OnlineSupport-Japan@avnet.com"
    const phoneNumber = System.getCurrentRegionWithType(apacAbbr) ? "86-755-2184-5922" : "03) 5792-8210"

    useEffect(() => {
        const c = System.getParams();
        async function fetchHere() {
            const params = {
                OrderId: c?.orderId,
                IsOrderPlaced: true
            }
            const detail = await fetch_place_order_items(params);
            if (detail && Object.entries(detail.payload).length > 0) {
                setCheckoutData(detail.payload);
                // open feedback popup
                if (localStorage.getItem(ORDER_FEEDBACK)) {
                    System.popup("PlaceOrderFeedback", {})
                }
                if (localStorage.getItem(CART_CHECKOUT_PLACE_ORDER)) {
                    cartPurchaseEvent(detail.payload);
                }
            }
            setTimeout(() => {
                __remove('CART_API_CALL', 'VIEW_CART_API_CALL')
            }, 500);
            setFirstServerCall(false)
        }

        if (sessionStorage.getItem(c.orderId)) {
            __set('CART_API_CALL', 'VIEW_CART_API_CALL'); // set same loader as like checkout total
            fetchHere()
            sessionStorage.setItem(SUCCESS_PAGE, SUCCESS_PAGE)
        } else {
            window.location.href = Order.getOrderRouteURL()
        }
        setTimeout(() => {
            sessionStorage.removeItem(c.orderId)
        }, 500);
    }, []);

    const renderAddress = (addressType, showAccountNo) => {
        const _address = checkoutData.orderAddress.find(f => f.addressType === addressType);
        if (_address) {
            return (
                <div className='d-flex justify-content-between '>
                    <div>
                        <div className="font-13 font-arial mt-2"><b>{_address.name}</b></div>
                        <p>{Helper.valueIsNotNull(_address?.lineOne) && _address?.lineOne + ","}
                            {Helper.valueIsNotNull(_address?.lineTwo) && (<><br />{_address?.lineTwo + ","}</>)}<br />
                            {Helper.valueIsNotNull(_address?.cityName) && _address?.cityName + ","}
                            {Helper.valueIsNotNull(_address?.stateName) ? _address?.stateName + "," : ""}
                            {Helper.valueIsNotNull(_address?.postalCode) && _address?.postalCode + ","}<br />{_address?.countryName}
                        </p>
                    </div>
                    <div>
                        {isCoreUser && showAccountNo && <p className='d-flex flex-column'><b>{t('shippingAccountNo')}.</b> {checkoutData?.shipToId}</p>}
                    </div>
                </div>
            )
        } else { return <></> }
    };

    useEffect(() => {
        if (checkoutData && Object.entries(checkoutData).length > 0 && document.getElementsByClassName('snippet') && document.getElementsByClassName('snippet').length > 0) {
            document.getElementsByClassName('snippet')[0].style.display = 'none';
        }
        if (firstServerCall === false && !monitorFunctionCall) {
            System.monitorJSDx()
            setMonitorFunctionCall(true)
        }
        if (checkoutData?.isFraudCheck) {
            system_alert_indicator({
                name: 'SuccessCheckout',
                message: t('orderUnderReview'),
                type: "warning"
            })
        }
    }, [checkoutData])

    useEffect(() => {
        Helper.feedBackButtonScript()
    }, []);

    const cartPurchaseEvent = (obj) => {
        let paymentInfo = {
            currencyCode: System.getRegionCurrency(),
            paymentAmount: obj?.orderEstimation?.orderTotal,
            paymentType: obj?.paymentMethod,
            transactionID: obj?.purchaseOrderNumber
        }
        let orderInfo = {
            orderPriceTotal: obj?.orderEstimation?.orderTotal,
            orderID: obj?.orderId,
            taxAmount: obj?.orderEstimation?.estimatedTax,
        }
        let cartItems = obj?.items?.map((x) => {
            return { ...x, ERPSupplierCode: cartProductData[x?.itemNumber]?.ERPSupplierCode, qas: x?.quantity, cartId: obj.cartId, purchaseOrderNumber: obj?.purchaseOrderNumber }
        });
        HelperAnalyticsEvent.purchaseEvent({ paymentInfo: paymentInfo, productList: cartItems ,orderInfo: orderInfo, shippingAmt: obj?.orderEstimation?.estimatedShipping, eventName: 'purchase' });
        localStorage.removeItem(CART_CHECKOUT_PLACE_ORDER);
    }

    return (
        <>
            {(checkoutData && Object.entries(checkoutData).length > 0) &&
                <>
                    {process.env.NODE_ENV !== "development" && <DOMAttachToSystem />}
                    <div className='checkout-process pt-3'>
                        <div className='container'>
                            {checkoutData?.isFraudCheck && <ShowAlert />}
                            <div className="order-placed-msg mt-3 mb-3">
                                <h2 className="text-center mt-0">
                                    <i className='orderplacetick'></i> {t('yourOrderHasBeenPlaced')}
                                </h2>
                                <div className="bs5 row">
                                    <div className="col-12">
                                        <p className='mb-2'>{t('thankyouShoppingAvnetConfirmationEmail')}: <b>{email}</b> {t('withYourOrder')}<br />
                                            {t('infoIfTheEmailHasntArrived')}</p>
                                        {checkoutData?.isFraudCheck && <p>
                                            <b className='mb-3' dangerouslySetInnerHTML={{ __html: t('orderUnderReview') }}></b>
                                        </p>}
                                    </div>
                                </div>
                                <div className="bs5 row">
                                    <div className="col-12 col-sm-12 col-lg-6 col-xl-6">
                                        <p><b>{t('webOrderNumber')}: </b>
                                            {checkoutData && checkoutData.orderId}
                                        </p>
                                        {checkoutData && checkoutData.purchaseOrderNumber && <p className="mb-0"><b>{t('purchaseOrderNumber')}:</b> {checkoutData && checkoutData.purchaseOrderNumber}</p>}
                                    </div>
                                    <div className="col-12 col-sm-12 col-lg-6 col-xl-6 d-flex">
                                        <ul className="ms-auto p-0 mb-0">
                                            <li onClick={() => { window.print() }}><img src={print} className='me-2' alt='print' /><a>{t('printThisPage')}</a></li>
                                            {System.getCurrentRegionWithType(apacAbbr) && <li><img src={phone} className='me-2' alt='Phone' /><span>{phoneNumber}</span></li>}
                                            <li><img src={emailicon} className='me-2' alt='Email' /><a href={`mailto:${emailId}`}>{emailId}</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="bs5 row">
                                <div className="col-12"></div>
                                <div className="col-12 col-sm-12 col-md-8 col-lg-9 col-xl-9">
                                    <div className="checkout-steps">
                                        <div className="shipping-address steps-inner mb-3 active completed">
                                            {ReusableDiv.checkoutStepTitle(`1. ${t('shippingAddress')}`)}
                                            <div className="shipping-address-detail checkbox-steps-content pt-0 pb-0">
                                                <div className="bs5 row">
                                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 pt-2 pb-2">
                                                        {renderAddress(SHIP_TO, true)}
                                                    </div>
                                                    {(checkoutData?.attn || checkoutData?.telephoneNumber || checkoutData?.softwareDownloadEmail) && <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                                        <div className="step-complete-show info-text h-100">
                                                            {checkoutData?.attn && <p><b>ATTN:</b> {checkoutData?.attn}</p>}
                                                            {checkoutData?.telephoneNumber && <p><b>{t('phoneNumber')}:</b> {checkoutData?.telephoneNumber}</p>}
                                                            {checkoutData?.softwareDownloadEmail && <p><b>{t('emailAddressForDownloadableProducts')}:</b> {checkoutData?.softwareDownloadEmail}</p>}
                                                        </div>
                                                    </div>}
                                                </div>
                                                <hr className="mb-0 mt-0 step-complete-hide" />
                                            </div>
                                        </div>
                                        <div className="shipping-method steps-inner mb-3 active completed">
                                            {ReusableDiv.checkoutStepTitle(`2. ${t('shippingMethod')}`)}
                                            <div className="checkbox-steps-content">
                                                <div className="step-complete-show">
                                                    <div className="bs5 row">
                                                        <div className="col-12">
                                                            {isOnlySoftwareParts ? <b>{t('orderContainsOnlySoftwareItems')}</b> :
                                                                <>
                                                                    <h3 className="text-uppercase">{t('shippingMethodOptions')}:</h3>
                                                                    {checkoutData?.orderCarrier?.carrierType === 'FreeShip' ?
                                                                        <p className='font-13 font-arial'><strong> {t('defaultShippingCompany')}</strong></p> :
                                                                        checkoutData?.orderCarrier?.carrierType === INCOTERM ?
                                                                            <p className='font-13 font-arial'><strong> {t('asPerIncoterm')}</strong></p> :
                                                                            <div>
                                                                                <span className='font-13 font-arial me-5'><strong> {checkoutData?.orderCarrier?.carrierKey}</strong></span>
                                                                                <span className='font-13 font-arial'>
                                                                                    {checkoutData?.orderCarrier?.carrierType === AVNET && System.getCurrentRegionWithType(japanAbbr) ? "¥600" :
                                                                                        checkoutData?.orderCarrier?.carrierType === MANUAL ? checkoutData?.orderCarrier?.carrierAccount :
                                                                                            checkoutData?.orderCarrier?.carrierOption}</span>
                                                                            </div>
                                                                    }
                                                                </>
                                                            }
                                                            {!isOnlySoftwareParts && <><hr />
                                                                <h3>{t('shippingPrefrences')}:</h3>
                                                                {checkoutData?.shippingPreference ?
                                                                    <p className='font-13 font-arial'>{t('combineAllItemsIntoOneShipment')}</p>
                                                                    :
                                                                    <>
                                                                        <p className='font-13 font-arial'><strong> {t('shipItemsAsTheyBecomeAvailable')}</strong></p>
                                                                        <p>{System.getCurrentRegionWithType(apacAbbr) && t('additionalFreightChargesMultipleShip')}</p>
                                                                    </>
                                                                }</>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="shipping-method steps-inner mb-3 active completed">
                                            {ReusableDiv.checkoutStepTitle(`3. ${t('paymentMethod')}`)}
                                            <div className="checkbox-steps-content">
                                                <div className="step-complete-show">
                                                    <div className="bs5 row">
                                                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                                            <h3 className="text-uppercase">{t('paymentMethod')}:</h3>
                                                            <p className='mt-2'>{
                                                                checkoutData?.paymentMethod === CreditCard ? (System.getCurrentRegionWithType(japanAbbr) ? t('creditDebitCard') : t('creditCard')) :
                                                                    checkoutData?.paymentMethod === DefaultPaymentTerm ? t('defaultPaymentTerms') :
                                                                        checkoutData?.paymentMethod === Alipay ? 'Alipay' :
                                                                            checkoutData?.paymentMethod === ChinaUnionPay ? 'China UnionPay' :
                                                                                checkoutData?.paymentMethod === WireTransfer ? (System.getCurrentRegionWithType(japanAbbr) ? t('advancePayment') : t('wireTransfer')) :
                                                                                    t('avnetCreditLine') + ' / ' + accountNumber}</p>
                                                        </div>
                                                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                                            <div className="inv-add">
                                                                <h3 className="text-uppercase">{t('invoiceAddress')}:</h3>
                                                                {renderAddress(Constants.addressType.BILL_TO, false)}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <CheckoutOrderItemList itemList={checkoutData.items} />
                                    </div>
                                </div>
                                <div className="col-12 col-sm-12 col-md-4 col-lg-3 col-xl-3">
                                    <CheckoutTotal isFrom={Constants.systemModules.SuccessCheckout} />
                                    <button type="button" className="bs5 btn btn-primary w-100 mt-2 d-block text-uppercase"
                                        onClick={() => {
                                            window.location.href = Product.getProductListingPageRouteURL()
                                        }}>{t('continueShopping')}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }

        </>
    );
}

export default SuccessCheckout;